import { Pipe, PipeTransform } from '@angular/core';
import { get } from 'lodash';
import * as moment from 'moment';
import { AppConfigService } from '../../app-config.service';

@Pipe({
  name: 'date',
  standalone: false
})
export class DatePipe implements PipeTransform {
  private readonly DATE_FORMAT_FR = 'D MMMM YYYY';
  private readonly DATE_FORMAT_EN = 'MMMM D, YYYY';

  constructor(private readonly _appConfigService: AppConfigService) {}

  transform(
    date: Date | string,
    langue: string = get(this._appConfigService, 'configData.contexteEnvironnement.langue', 'fr')
  ): string {
    moment.locale(langue);
    let formattedDate = '-';

    if (date) {
      if (langue === 'en') {
        formattedDate = moment(date).format(this.DATE_FORMAT_EN);
      } else {
        formattedDate = moment(date).format(this.DATE_FORMAT_FR);
      }
    }

    return formattedDate;
  }
}
